var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-headers" },
    [
      _c(
        "div",
        { staticClass: "table-header-cell record-id-header" },
        [
          _c("a-checkbox", {
            attrs: { checked: _vm.isAllSelected },
            on: {
              change: function ($event) {
                return _vm.$emit("toggle-select-all", $event.target.checked)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.visibleFields, function (field) {
        return _c(
          "div",
          {
            key: field._id,
            staticClass: "table-header-cell",
            class: { selected: _vm.selectedField === field },
            on: {
              click: function ($event) {
                return _vm.selectField(field)
              },
            },
          },
          [
            _c(
              "a-popover",
              { attrs: { trigger: "click", placement: "bottomLeft" } },
              [
                _c("template", { slot: "content" }, [
                  _c(
                    "div",
                    { staticClass: "action-list field-actions-menu" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "action-item",
                          on: {
                            click: function ($event) {
                              return _vm.handleAction("editField", field)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("edit"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Edit Field")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "action-group" }, [
                        _c("div", { staticClass: "group-name" }, [
                          _vm._v("Sort"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("sortAscending", field)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("arrow_upward"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Ascending")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("sortDescending", field)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("arrow_downward"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Descending")]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "action-group" }, [
                        _c("div", { staticClass: "group-name" }, [
                          _vm._v("Create Field"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("insertBefore", field)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Insert Before")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("insertAfter", field)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Insert After")]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "action-group" }, [
                        _c("div", { staticClass: "group-name" }, [
                          _vm._v("Automation"),
                        ]),
                        _vm._v(" "),
                        field.fieldType === "automation-button"
                          ? _c(
                              "div",
                              {
                                staticClass: "action-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAction(
                                      "gotoAutomation",
                                      field
                                    )
                                  },
                                },
                              },
                              [
                                _c("atomic-power", {
                                  tag: "component",
                                  staticClass: "myIcon",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("Go to Related Automation"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction(
                                  "createAutomation",
                                  field
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("settings_suggest"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Create Automation")]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "action-group" }, [
                        _c("div", { staticClass: "group-name" }, [
                          _vm._v("Permissions"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("lockField", field)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("lock"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Lock Field")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("hideField", field)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("visibility_off"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Hide Field")]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-divider"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "action-item",
                          on: {
                            click: function ($event) {
                              return _vm.handleAction("deleteField", field)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("delete"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Delete Field")]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-header-cell-content" }, [
                  _c("i", { staticClass: "material-icons mr-2" }, [
                    _vm._v(_vm._s(_vm.getIcon(field))),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(field.name))]),
                ]),
              ],
              2
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-header-cell add-field-cell" },
        [
          _c(
            "a-popover",
            {
              ref: "addFieldPopover",
              attrs: { trigger: "click", placement: "bottomRight" },
            },
            [
              _c(
                "template",
                { slot: "content" },
                [
                  _c("FieldSelector", {
                    on: { "field-selected": _vm.openFieldCreator },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v("+ " + _vm._s(_vm.$t("calendar.addField")))]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isFieldCreatorVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("tables.createNewField"),
                showFooter: false,
              },
              on: { cancel: _vm.closeFieldCreator },
            },
            [
              _c("FieldCreator", {
                attrs: {
                  defaultFieldType: _vm.selectedFieldType,
                  "table-id": _vm.table._id,
                },
                on: {
                  "field-created-success": _vm.onFieldCreated,
                  cancel: _vm.closeFieldCreator,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }